import React, { Component, useState } from 'react';
import MoreInfoView from './MoreInfoView';
import PrivacyPolicyView from './PrivacyPolicyView';
import { getAppCfg } from '../../utils/common';
import AboutView from './AboutView';
import FAQsView from './FAQsView';
import TermAndConditionsView from './TermAndConditionsView';
import ContactUsView from './ContactUsView';

function MoreInfo(props){
    const [open, setOpen] = useState({privacy: false});

    var app_config = getAppCfg()
    const about_details = app_config&&app_config.about_details? app_config.about_details : null;
    //const partner_creatives = app_config && app_config.creatives ? app_config.creatives : [];
    const partner_creatives = app_config && app_config.partner_creatives ? app_config.partner_creatives : [];
    
    const onClickItem = (item) =>{
        if(item.url){
            window.open(item.url, "_blank");
        }else{
            setOpen(prevState => ({
                ...prevState,
                [item.id] : true
            }));
        }
    }
    const onCloseItem = (value) =>{
        setOpen(prevState => ({
            ...prevState,
            [value] : false
        }));
    }

    return (
        <div>
            {/* <MoreInfoMenu open={this.props.openMoreInfo} handleDrawerToggle={this.props.handleDrawerToggleMF} /> */}
            <MoreInfoView 
                open = {props.open}
                handleDrawerOtherToggle = {props.handleDrawerOtherToggle}
                onClickItem = {onClickItem}/>
            <PrivacyPolicyView
                open = {open.privacy}
                onCloseItem = {onCloseItem}
                about_details = {about_details}  />
            <AboutView
                open = {open.about}
                onCloseItem = {onCloseItem}
                about_details = {about_details}
                partner_creatives={partner_creatives}  />
            <FAQsView
                open = {open.faq}
                onCloseItem = {onCloseItem}
                about_details = {about_details}  />
            <TermAndConditionsView
                open = {open.term_conditions}
                onCloseItem = {onCloseItem}
                about_details = {about_details}  />
            <ContactUsView
                open = {open.contact_us}
                onCloseItem = {onCloseItem}
                about_details = {about_details}  />
        </div>
    );
}

export default MoreInfo;